import { AlertV4, ChipV4, ModalV4 } from "../common/ui";
import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";

import {
  CATEGORY_LABELS,
  codeOf,
  createdTimeOf,
  type DoneRow,
  type getLogRows,
} from "./ordersModelV4";

// Types
type ModalOrderLogV4Props = {
  // data
  row: DoneRow;
  logRows: ReturnType<typeof getLogRows>;
  isLoading: boolean;
  error?: unknown;
  // callback
  onClose: () => void;
};

const ModalOrderLogV4 = (props: ModalOrderLogV4Props) => {
  const { row } = props;

  // Render
  return (
    <ModalV4 title="Log การสร้าง / แก้ไข Order" width={820} onClose={props.onClose}>
      <div className="hv4-ord-log-body">
        <div className="hv4-ord-cancel-sub">
          {[
            codeOf(row),
            CATEGORY_LABELS[row.category],
            createdTimeOf(row) ? `สร้าง ${createdTimeOf(row)}` : "",
            row.isCancelled ? "ยกเลิกแล้ว" : "",
          ]
            .filter(Boolean)
            .join(" · ")}
        </div>
        {!!props.error && (
          <AlertV4 tone="danger" error={props.error}>
            โหลด Log ไม่สำเร็จ:{" "}
          </AlertV4>
        )}
        {props.isLoading ? (
          <div role="status" className="hv4-ord-cancel-sub">
            กำลังโหลด Log…
          </div>
        ) : (
          <table className="hisv4-table hv4-ord-log-table">
            <thead>
              <tr>
                <th>เวลา</th>
                <th>Status</th>
                <th>การดำเนินการ</th>
                <th>ผู้ดำเนินการ</th>
              </tr>
            </thead>
            <tbody>
              {props.logRows.map((log, index) => (
                <tr key={index}>
                  <td>{formatISOtoBEDateTime(log.datetime).timeShort}</td>
                  <td>
                    <ChipV4
                      size="sm"
                      bold
                      tone={log.status === "Cancelled" ? "danger-solid" : "blue-solid"}
                    >
                      {log.status}
                    </ChipV4>
                  </td>
                  <td>
                    <b>{log.text}</b>
                  </td>
                  <td>{("name" in log && log.name) || ("user_name" in log && log.user_name)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </ModalV4>
  );
};

ModalOrderLogV4.displayName = "ModalOrderLogV4";

export default ModalOrderLogV4;
